import Breakpoint from 'bootstrap-breakpoints'
import Video from './modules/Video'
import { lazyImages } from './modules/LazyImages'
import ProgramsSlider from './modules/ProgramsForYouSlider'
import AnimateOnScroll from './modules/AnimateOnScroll'

document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
    // document is ready. Do your stuff here

    Breakpoint.init()

    lazyImages()

    document.querySelectorAll('.b-video').forEach((i) => {
      new Video(i)
    })

    document.querySelectorAll('.s-programs-for-you').forEach((i) => {
      new ProgramsSlider(i)
    })

    document.querySelectorAll('.animate-on-scroll').forEach((i) => {
      new AnimateOnScroll(i)
    })
  }
}
